import React, { Component } from "react";
import axios from "axios";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import { withOktaAuth } from "@okta/okta-react";
import jwt_decode from "jwt-decode";
import Header from "../../header/header";
import { getHeadersOrder } from "../../utility/utility";

class d2bRejectQueueMonitor extends Component {
  state = {
    mtcn: "",
    date: "",
    checkboxOptions: "",
    submitStatusD2BRejectQueueMonitor: null,
    submitMsgD2BRejectQueueMonitor: "",
    selectedItems: [],
    rows: ['OV', 'VIGO', 'WU'],
    records: [],
    arr: [],
  };
  componentDidMount() {
    const accessToken = this.props.authState.accessToken;
    const tokenD2BRQM = accessToken.value;
    try {
      const token = jwt_decode(accessToken.value);
      const accessRole = jwt_decode(accessToken.value).appRoles;
      const id = jwt_decode(accessToken.value).hqintlId;
      const operatorIdD2BRQM = id.replace(/\D/g, "");
      const accessGrantD2BRQM =
        accessRole.includes(
          process.env.REACT_APP_DB_VIEW_SUPERUSER_READ_ACCESS
        ) ||
        accessRole.includes(
          process.env.REACT_APP_DB_VIEW_SUPERUSER_READWRITE_ACCESS
        ) ||
        accessRole.includes(process.env.REACT_APP_DB_VIEW_QQCMANAGER) ||
        accessRole.includes(process.env.REACT_APP_DB_VIEW_QQCCLERK) ||
        accessRole.includes(process.env.REACT_APP_DB_VIEW_QQCDELIVERYMONITOR);

      this.setState(
        {
          accessToken: token,
          tokenD2BRQM: tokenD2BRQM,
          operatorIdD2BRQM: operatorIdD2BRQM,
          role: accessRole,
          accessGrantD2BRQM: accessGrantD2BRQM,
        },
        () => {
          if (!this.state.accessGrantD2BRQM) {
            this.setState({
              submitStatusD2BRejectQueueMonitor: "Error",
              submitMsgD2BRejectQueueMonitor: "Unauthorized! Access Is Denied.",
            });
          }
        }
      );
      // valid token format
    } catch (error) {
      // invalid token format
    }

  }
  onChangeControlD2BRejectQueueMonitor = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  covertToLegacyD2BRQM = (date) => {
    let d1 = new Date(date);
    let newStartDateD2BRQM = [
      ("0" + (d1.getMonth() + 1)).slice(-2),
      ("0" + d1.getDate()).slice(-2),
      d1.getFullYear(),
    ].join("/");
    return newStartDateD2BRQM;
  };

  onValidateD2BRejectQueueMonitor = () => {
    let mtcn = this.state.mtcn.trim();
    if (
      this.state.mtcn === "" &&
      this.state.date === "" &&
      this.state.arr.length < 1
    ) {
      this.setState({
        submitStatusD2BRejectQueueMonitor: "Error",
        submitMsgD2BRejectQueueMonitor:
          "Que Groups, MTCN And Date Fields Are Empty Or Invalid. Please Make Some Selection",
      });
      return false;
    }
    if (mtcn.length > 0 && mtcn.length < 10) {
      this.setState({
        submitStatusD2BRejectQueueMonitor: "Error",
        submitMsgD2BRejectQueueMonitor: "Please Enter A 10 Digit Valid MTCN",
      });
      return false;
    }
    return true;
  };

  onChangeCheckBoxD2BRejectQueueMonitor = (params, e) => {
    let { value } = e.target;
    let queueArray = this.state.arr;
    let arrayIndex = this.state.arr.indexOf(value);
    if (arrayIndex === -1) {
      queueArray.push(value);
      this.setState({ arr: queueArray });
    } else {
      let array = this.state.arr;
      array.splice(arrayIndex, 1);
      this.setState({ arr: array });
    }
  };

  onHandleSearchD2BRejectQueueMonitor = () => {
    if (!this.onValidateD2BRejectQueueMonitor()) {
      return;
    }

    let submittedObjD2BRQM = {};
    let rejectQueueTransactionRequest = {};
    rejectQueueTransactionRequest.mtcn = this.state.mtcn;
    rejectQueueTransactionRequest.startdate =
      this.state.date === "" ? "" : this.covertToLegacyD2BRQM(this.state.date);
    rejectQueueTransactionRequest.queueNameList = this.state.arr;
    submittedObjD2BRQM.rejectQueueTransactionRequest = rejectQueueTransactionRequest;
    axios
      .post(
        `${process.env.REACT_APP_DB_VIEW_BASE_ORDER_SERVICE_URL}/v1/ord/dbview/queueagemonitor/queuetransaction`,
        submittedObjD2BRQM,
        {
          headers: {
            ...getHeadersOrder().headers,
            Authorization: `${this.state.tokenD2BRQM}`,
            userId: this.state.operatorIdD2BRQM,
          },
        }
      )
      .then((response) => {
        response.data.records.forEach((item) => {
          item.mtcn10 = item.mtcn ? item.mtcn.substring(6, 16) : "";
        });
        this.props.history.push({
          pathname: "/d2b-reject-queue-txn-screen",
          state: {
            data: this.state,
            records: response.data.records,
          },
        });
      });
  };
  render() {
    return (
      <>
        <Header history={this.props.history} heading="QUEUE AGE MONITOR" />
        <div className="container-fluid">
          <div className="card-body">
            <h4 className="card-title main-heading ">
              D2B REJECT QUEUE MONITOR
            </h4>
            <div className="card">
              <div className=" bg-dark text-white card-header-custom">
                QUEUE GROUPS
              </div>
              <div className="card-body">
                <div className="card-body file-alert mar-bottom5" id="queue-card-box">
                  <div className="form-group row">
                  <div className="col-lg-4">
                    <div className="form-check">
                      {this.state.rows.map((grp, i) => (
                        <div key={i}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="checkboxOptions"
                            id={grp}
                            value={grp}
                            onChange={(e) => {
                              this.onChangeCheckBoxD2BRejectQueueMonitor(grp, e);
                            }}
                          />
                          <label className="form-check-label">
                            {grp}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                  <div className=" bg-dark text-white card-header-custom">
                    GLOBAL SELECTION CRITERIA
                  </div>
                  <div className="card">
                    <div className="card-body">
                      <div className="form-group row">
                        <div className="col-lg-6">
                          <label htmlFor="mtcn" className="font-weight-bold">
                            MTCN
                          </label>
                          <input
                            type="text"
                            inputmode="numeric" 
                            pattern="\d{10}" 
                            maxlength="10" 
                            className="form-control form-control-sm"
                            name="mtcn"
                            value={this.state.mtcn}
                            onChange={(e) => {
                              this.onChangeControlD2BRejectQueueMonitor(e);
                            }}
                          />
                        </div>
                        <div className="col-lg-6">
                          <Form.Label className="font-weight-bold">
                            Start Date
                          </Form.Label>
                          <Form.Control
                            type="date"
                            name="date"
                            value={this.state.date}
                            onChange={(e) => {
                              this.onChangeControlD2BRejectQueueMonitor(e);
                            }}
                          />
                        </div>
                      </div>
                      <Card.Text>(10 Digit. For ex: 3456129442)</Card.Text>
                    </div>
                    <div className="form-group row">
                      <div className="col-lg-5" />
                      <div className="col-lg-7">
                        <button
                          type="button"
                          className="btn btn-warning"
                          onClick={this.onHandleSearchD2BRejectQueueMonitor}
                          data-test="button-search"
                          disabled={!this.state.accessGrantD2BRQM}
                        >
                          SEARCH
                        </button>
                      </div>
                      <div className="col-lg-0" />
                    </div>
                    <div className="form-group row">
                      <div className="col-lg">
                        {this.state.submitStatusD2BRejectQueueMonitor === "Error" && (
                          <div className="alert alert-danger alert-padding notification text-center">
                            {this.state.submitMsgD2BRejectQueueMonitor}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withOktaAuth(d2bRejectQueueMonitor);
